export default "__VITE_ASSET__ByNjI3qo__"